import type { IPagination } from '@/interfaces'

class Pagination<T> implements IPagination {
  offset: number

  limit: number

  responseRowCount?: number

  loading?: boolean

  totalRowCount: number

  noData?: boolean

  data: Array<T> | null

  selectedItems: Array<any>

  temporarySelectedItems: Array<any>

  isAllListItemsSelected: boolean

  isSelectedAllSnackbarItems: boolean

  currentPageSize: number

  cookie?: null | undefined

  selectedItemsData: any[] | null

  constructor(pageData: any) {
    this.offset = pageData.value.length
    this.limit = pageData.limit
    this.responseRowCount = pageData.value.length
    this.loading = pageData.loading
    this.totalRowCount = pageData.size
    this.noData = pageData.totalRowCount === 0
    this.data = pageData.value
    this.selectedItems = pageData.selectedItems
    this.temporarySelectedItems = pageData.temporarySelectedItems
    this.isAllListItemsSelected = pageData.isAllListItemsSelected
    this.isSelectedAllSnackbarItems = pageData.isSelectedAllSnackbarItems
    this.currentPageSize = pageData.currentPageSize
    this.cookie = pageData.cookie
    this.selectedItemsData = pageData?.selectedItemsData
  }
}

export default Pagination
